export const pocActionTypes = {
  UPLOAD_IMAGE: 'UPLOAD_IMAGE',
  CREATE_POC: 'CREATE_POC',
  GET_POC_DATA: 'GET_POC_DATA',
  SET_POC_DATA: 'SET_POC_DATA',
  SET_LOADING: 'SET_LOADING',
  GET_APPLICATION_INFO: 'GET_APPLICATION_INFO',
  SET_APPLICATION_INFO: 'SET_APPLICATION_INFO',
  GET_ATTENDANCE_DATA: 'GET_ATTENDANCE_DATA',
  SET_ATTENDANCE_DATA: 'SET_ATTENDANCE_DATA',
  GET_USER_TOKEN_OPTIONS: 'GET_USER_TOKEN_OPTIONS',
  SET_USER_TOKEN_OPTIONS: 'SET_USER_TOKEN_OPTIONS',
};
